// store.js
import { configureStore } from '@reduxjs/toolkit';
import postsReducer from '../Features/Slices/PostSlice';
import RegistrationSlice from '../Features/Slices/RegistrationSlice';
import GetBankMasterSlice from '../Features/Slices/GetBankMasterSlice';
import updatePostSlice from "../Features/Slices/UpdateSlice";
import GetDataSlice from '../Features/Slices/GetDataSlice';
import DynamicTokenPatchSlice from '../Features/Slices/DynamicTokenPatchSlice';
import DynamicTokenPostSlice from '../Features/Slices/DynamicTokenPostSlice';
import DynamicTokenPostJsonSlice from '../Features/Slices/DynamicTokenPostJsonSlice';
import employeeDataReducer from '../Features/Slices/employeeDataSlice';
import getRequestReducer from '../Features/Slices/GetRequestSlice';
import getPlainRequestReducer from '../Features/Slices/GetPlainRequestSlice';

const store = configureStore({
  reducer: {
    postsReducer: postsReducer,
    RegistrationSlice: RegistrationSlice,
    GetBankMasterSlice: GetBankMasterSlice,
    updatePostSlice: updatePostSlice,
    GetDataSlice: GetDataSlice,
    DynamicTokenPatchSlice: DynamicTokenPatchSlice,
    DynamicTokenPostSlice: DynamicTokenPostSlice,
    DynamicTokenPostJsonSlice: DynamicTokenPostJsonSlice,
    employeeData: employeeDataReducer,
    getRequest: getRequestReducer, 
       getPlainRequest: getPlainRequestReducer, 

  },
});

export default store;
